import React, { useRef, useState } from "react";
import {
  Card,
  CardBody,
  Table,
  Button,
  Offcanvas,
  OffcanvasHeader,
} from "reactstrap";
import numberToWords from "../../../../../Components/Common/numberToWords";
import html2pdf from "html2pdf.js";
import ReceiptPrint from "../../../BillPrint/page/ReceiptPrint";

const InvoiceSummaryMobile = ({
  isOpen,
  toggle,
  orgInfo,
  user,
  selectedTable,
  orderId,
  items,
  calculateTotals,
  paymentStatus,
  selected,
  handleCheckout,
  handleSelect,
  promoSuccess,
  discountAmount,
  discountPercent,
  selectedCustomer,
  selectedPayment,
  rawOrder,
  responseData,
  userInfo,
}) => {
  const billRef = useRef();
  const handleDownload = () => {
    const element = billRef.current;
    html2pdf()
      .set({
        margin: 0.5,
        filename: `Invoice-${responseData?.invoiceNumber || "Bill"}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
      })
      .from(element)
      .save();
  };

  const [expandedItems, setExpandedItems] = useState({});
  const toggleChildren = (itemKey) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemKey]: !prev[itemKey],
    }));
  };
  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="bottom"
      scrollable={true}
      style={{
        height: "95vh",
        transition: "transform 0.3s ease",
        borderTopLeftRadius: "1rem",
        borderTopRightRadius: "1rem",
        zIndex: 1050,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="d-flex flex-column h-100">
        <OffcanvasHeader toggle={toggle} className="p-3 ">
          <h6>Estimate Invoice</h6>
        </OffcanvasHeader>
        <div ref={billRef}>
          <div style={{ flex: 1, overflowY: "auto" }} className="p-2">
            <Card className="border-1 rounded-3">
              <CardBody
                className="d-flex flex-column p-3"
                style={{ fontFamily: "monospace", fontSize: "14px" }}
              >
                {/* Header */}
                <div className="text-center mb-2">
                  <h5 className="fw-bold text-uppercase mb-0 ">
                    {userInfo?.categoryId === null
                      ? orgInfo?.name
                      : userInfo?.subOrgName}
                  </h5>
                  <div className="text-uppercase">
                    {orgInfo?.address1 || ""}
                  </div>
                  <div>
                    {userInfo?.categoryId === null
                      ? orgInfo?.tel
                      : userInfo?.subOrgPhone}
                  </div>
                  <div className="fw-bold mt-1 text-uppercase">
                    Provisional Invoice
                  </div>
                </div>

                {/* Info Rows */}
                <div className="d-flex justify-content-between small mb-1">
                  <div>
                    <strong>PAN No.:</strong>{" "}
                    {userInfo?.categoryId === null
                      ? orgInfo?.panNumber
                      : userInfo?.subOrgPan}
                  </div>
                  <div>
                    <strong>Copy of:</strong> Original
                  </div>
                </div>
                <div className="d-flex justify-content-between small mb-1">
                  <div>
                    <strong>Customer:</strong>{" "}
                    {selectedCustomer
                      ? `${selectedCustomer.firstName} ${selectedCustomer.lastName}`
                      : "...."}
                  </div>
                  <div>
                    <strong>PAN:</strong> {"..."}
                  </div>
                </div>
                <div className="d-flex justify-content-between small mb-1">
                  <div>
                    <strong>Phone No.:</strong>{" "}
                    {selectedCustomer?.phoneNo || "...."}
                  </div>
                  <div>
                    <strong>Cashier:</strong> {user?.name || "..."}
                  </div>
                </div>
                <div className="d-flex justify-content-between small mb-1">
                  <div>
                    <strong>Address:</strong>{" "}
                    {selectedCustomer?.address || "...."}
                  </div>
                  <div>
                    <strong>INV No:</strong> {orderId || "..."}
                  </div>
                </div>
                {/* <div className="d-flex justify-content-between small mb-2">
                  <div>
                    <strong>Date (B.S.):</strong> ...
                  </div>
                  <div>
                    <strong>Date (A.D.):</strong>{" "}
                    {new Date().toLocaleDateString("en-GB")}
                  </div>
                </div> */}
                <div className="d-flex justify-content-between small mb-2">
                  <div>
                    <strong>Table:</strong> {selectedTable?.tableName || "T-1"}
                  </div>
                  <div>
                    <strong>Time:</strong>{" "}
                    {new Date().toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </div>
                </div>

                {/* Table */}
                <Table
                  size="sm"
                  responsive
                  className="table-bordered small mb-0"
                >
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>Item</th>
                      <th className="text-center">Qty</th>
                      <th className="text-center">Rate</th>
                      <th className="text-end">Amnt</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, index) => {
                      const itemKey = `${item?.tableId}-${index}`;
                      const isExpanded = expandedItems[itemKey];

                      // ----- Complimentary Row -----
                      const ComplimentaryRow =
                        item?.complimentaryQuantity > 0 ? (
                          <tr key={`${index}-comp`}>
                            <td>{index + 1}</td>

                            <td className="text-level-2">
                              <h6 className="fw-semibold mb-1 text-info">
                                {item.productName} (Free)
                              </h6>

                              {/* Expandable attributes and children */}
                              <div
                                className="overflow-hidden"
                                style={{
                                  maxHeight: isExpanded
                                    ? `${item.children?.length * 50}px`
                                    : "0px",
                                  transition: "max-height 0.3s ease",
                                }}
                              >
                                {item?.children?.map((child, i) => (
                                  <div key={i} className="mt-2">
                                    <div className="d-flex justify-content-between">
                                      <small>+ {child.productName}</small>
                                      <small>{child.productPrice}</small>
                                    </div>

                                    {child?.attributes?.map((attr) => (
                                      <small
                                        key={attr.id}
                                        className="text-muted d-block ms-2"
                                      >
                                        - {attr.title}
                                      </small>
                                    ))}
                                  </div>
                                ))}
                              </div>

                              <div
                                className="overflow-hidden"
                                style={{
                                  maxHeight: isExpanded
                                    ? `${item.attributes?.length * 50}px`
                                    : "0px",
                                  transition: "max-height 0.3s ease",
                                }}
                              >
                                {item?.attributes?.map((attr, i) => (
                                  <div key={i} className="mt-2">
                                    <div className="d-flex justify-content-between">
                                      <small>+ {attr.title}</small>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </td>

                            {/* Qty */}
                            <td className="text-center text-primary">
                              {item.complimentaryQuantity}
                            </td>

                            {/* Rate = 0 */}
                            <td className="text-end text-primary">0.00</td>

                            {/* Amount = 0 */}
                            <td className="text-end text-primary">0.00</td>
                          </tr>
                        ) : null;

                      // ----- Normal Row -----
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{index + 1}</td>

                            <td className="text-level-2">
                              <h6
                                className={`fw-semibold mb-1 ${
                                  item?.children?.length > 0 ||
                                  item?.attributes?.length > 0
                                    ? "text-secondary cursor-pointer"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleChildren(itemKey);
                                }}
                              >
                                {item.productName}
                              </h6>

                              {/* Expandable Children */}
                              <div
                                className="overflow-hidden"
                                style={{
                                  maxHeight: isExpanded
                                    ? `${item.children?.length * 50}px`
                                    : "0px",
                                  transition: "max-height 0.3s ease",
                                }}
                              >
                                {item?.children?.map((childItem, i) => (
                                  <div key={i} className="mt-2">
                                    <div className="d-flex justify-content-between">
                                      <small>+ {childItem.productName}</small>
                                      <small>{childItem?.productPrice}</small>
                                    </div>
                                    {childItem?.attributes?.map((attr) => (
                                      <small
                                        key={attr.id}
                                        className="text-muted d-block ms-2"
                                      >
                                        - {attr.title}
                                      </small>
                                    ))}
                                  </div>
                                ))}
                              </div>

                              {/* Expandable Attributes */}
                              <div
                                className="overflow-hidden"
                                style={{
                                  maxHeight: isExpanded
                                    ? `${item.attributes?.length * 50}px`
                                    : "0px",
                                  transition: "max-height 0.3s ease",
                                }}
                              >
                                {item?.attributes?.map((attr, i) => (
                                  <div key={i} className="mt-2">
                                    <div className="d-flex justify-content-between">
                                      <small>+ {attr.title}</small>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </td>

                            {/* Quantity */}
                            <td className="text-center">{item.quantity}</td>

                            {/* Rate */}
                            <td className="text-end text-level-3">
                              {(() => {
                                const attrTotal = item?.attributes?.reduce(
                                  (sum, a) => sum + (Number(a.value) || 0),
                                  0
                                );
                                const childrenTotal = item?.children?.reduce(
                                  (sum, c) =>
                                    sum + (Number(c.productPrice) || 0),
                                  0
                                );
                                const basePrice =
                                  Number(item?.productPrice) || 0;

                                const unitPrice =
                                  attrTotal || childrenTotal
                                    ? basePrice + attrTotal + childrenTotal
                                    : basePrice;

                                return unitPrice.toFixed(2);
                              })()}
                            </td>

                            {/* Amount */}
                            <td className="text-end text-level-3">
                              {(() => {
                                const attrTotal = item?.attributes?.reduce(
                                  (sum, a) => sum + (Number(a.value) || 0),
                                  0
                                );
                                const childrenTotal = item?.children?.reduce(
                                  (sum, c) =>
                                    sum + (Number(c.productPrice) || 0),
                                  0
                                );
                                const basePrice =
                                  Number(item?.productPrice) || 0;
                                const qty = Number(item?.quantity) || 0;

                                const unitPrice =
                                  attrTotal || childrenTotal
                                    ? basePrice + attrTotal + childrenTotal
                                    : basePrice;

                                return (unitPrice * qty).toFixed(2);
                              })()}
                            </td>
                          </tr>

                          {/* Complimentary Row Inserted Here */}
                          {ComplimentaryRow}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </Table>

                {/* Totals */}
                <div className="border-top pt-2 small">
                  <div className="d-flex justify-content-between">
                    <div>Total Qty:</div>
                    <div>
                      {items?.reduce(
                        (total, item) =>
                          total +
                          item?.quantity +
                          (item?.complimentaryQuantity || 0),
                        0
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div
                      onClick={() => {
                        console.log(calculateTotals);
                      }}
                    >
                      Sub Total:
                    </div>
                    <div>Rs. {calculateTotals?.subTotal?.toFixed(2)}</div>
                  </div>
                  {/* <div className="d-flex justify-content-between">
                  <div>Discount Amount:</div>
                  <div>-Rs {calculateTotals.discount.toFixed(2)}</div>
                </div> */}

                  {(promoSuccess || discountAmount) && (
                    <div className="d-flex justify-content-between">
                      <div>Discount Amount:</div>
                      <div>Rs {calculateTotals.discount.toFixed(2)}</div>
                    </div>
                  )}
                  <div className="d-flex justify-content-between fw-bold">
                    <div>Net Amount:</div>
                    <div>Rs. {calculateTotals.total.toFixed(2)}</div>
                  </div>
                  <div className="mt-2">
                    <div>
                      <strong>In Words:</strong>{" "}
                      {numberToWords(calculateTotals.total)}
                    </div>
                  </div>
                  <div className="mt-2">
                    <div>
                      Payment Mode: {selectedPayment?.name} (Rs{" "}
                      {calculateTotals.total.toFixed(2)})
                    </div>
                  </div>
                  <div className="mt-2">
                    <div>Billed by: {user?.name || "Staff"}</div>
                  </div>
                </div>

                {/* Footer Info */}
                <div className="small mt-2">
                  <div className="text-center mt-2">**Thank You**</div>
                  <div className="text-center text-muted small">
                    Powered by Restro Order
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>

        <div className="p-2 border-1 shadow-sm border-top position-sticky sticky-bottom d-flex gap-2">
          <button
            className="btn btn-soft-success shadow-sm d-flex align-items-center justify-content-center gap-2 "
            onClick={handleDownload}
          >
            <i className="ri-download-line me-1"></i>
            Download
          </button>

          <div className="">
            <ReceiptPrint
              selectedCustomer={selectedCustomer}
              selectedPayment={selectedPayment}
              rawOrder={rawOrder}
              promoSuccess={promoSuccess}
              discountAmount={discountAmount}
              orgInfo={orgInfo}
              user={user}
              selectedTable={selectedTable}
              orderId={orderId}
              items={items}
              calculateTotals={calculateTotals}
            />
          </div>
        </div>
      </div>
    </Offcanvas>
  );
};

export default InvoiceSummaryMobile;
